import BaseModel from 'volta/models/base-model';
import { _normalize, collectionCommand, resourceCommand as command } from 'volta/utils/api';

import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

import type { TAcquisitionCode } from 'volta/models/constants/acquisition-codes';
import type { TLeadTimeCategory } from 'volta/models/constants/lead-time-categories';
import type { TVarCategory } from 'volta/models/constants/var-categories';
import type { IUpdateBufferProfileCmd } from 'volta/models/types/buffer-profile';
import type { TBufferZoneUnit } from './types/planning-settings';

export const ResourceName = {
  singular: 'bufferProfile',
  plural: 'bufferProfiles'
};

export const Commands = {
  UpdateBufferProfile: 'UpdateBufferProfile',
  CreateBufferProfile: 'CreateBufferProfile'
};

export default class BufferProfile extends BaseModel {
  /**
   * Collection commands
   */
  static createBufferProfile = collectionCommand<
    IUpdateBufferProfileCmd,
    BufferProfile,
    typeof BufferProfile
  >(Commands.CreateBufferProfile);

  @attr('string') declare code: string;
  @attr('string') description?: string;
  @attr('number', { defaultValue: 1 }) varFactor?: number;
  @attr('number', { defaultValue: 0 }) varFactorMin?: number;
  @attr('number', { defaultValue: 1 }) varFactorMax?: number;
  @attr('number', { defaultValue: 1 }) leadTimeFactor?: number;
  @attr('number', { defaultValue: 0 }) leadTimeFactorMin?: number;
  @attr('number', { defaultValue: 1 }) leadTimeFactorMax?: number;
  @attr('string') varCategory?: TVarCategory;
  @attr('string') leadTimeCategory?: TLeadTimeCategory;
  @attr('string') acqCode?: TAcquisitionCode;
  @attr('number') fixedRedBase?: number;
  @attr('string') fixedRedBaseUnit?: TBufferZoneUnit;
  @attr('number') fixedRedSafety?: number;
  @attr('string') fixedRedSafetyUnit?: TBufferZoneUnit;
  @attr('number') fixedYellow?: number
  @attr('string') fixedYellowUnit?: TBufferZoneUnit;
  @attr('number') fixedGreen?: number;
  @attr('string') fixedGreenUnit?: TBufferZoneUnit;
  @attr('boolean', { defaultValue: false }) declare isDefault: boolean;
  @attr('array', {
    defaultValue: () => []
  })
  declare tags: string[];

  get bufferProfileId() {
    return this.id;
  }

  /**
   * Commands
   */

  updateBufferProfile = command<IUpdateBufferProfileCmd, BufferProfile>(
    Commands.UpdateBufferProfile
  );

  [Type] = 'buffer-profile' as const;
}
